import React, { Component } from 'react';

import APIDocsCurl from 'common/developers/docs/api/APIDocsCurl';
import APIDocsMethod from 'common/developers/docs/api/APIDocsMethod';
import Highlight from 'common/developers/docs/api/Highlight';

import APIDocsBlock from '../APIDocsBlock';
import APIDocsTable from '../APIDocsTable';

export default class APIDocsListEntriesBlock extends Component {
  render() {
    return (
      <APIDocsBlock>
        <div>
          <div className="heading">List opportunties</div>
          <div className="text">Returns a list of opportunities linked to posts in Canny.</div>
          <APIDocsTable
            title="Arguments"
            rows={[
              {
                description: 'Your secret API key.',
                heading: 'apiKey',
                subheading: 'string',
              },
              {
                description:
                  "The number of opportunities you'd like to fetch. Defaults to 10 if not specified.",
                heading: 'limit',
                subheading: 'number (optional)',
              },
              {
                description:
                  "The number of opportunities you'd like to skip before starting to fetch. Defaults to 0 if not specified.",
                heading: 'skip',
                subheading: 'number (optional)',
              },
            ]}
          />
          <div className="subheading">Returns</div>
          <div className="text">
            A dictionary with an "opportunities" property that contains an array of opportunity
            objects. There's also a "hasMore" property that specifies whether this query returns
            more opportunities than the&nbsp;limit.
          </div>
        </div>
        <div>
          <div className="text">Endpoint</div>
          <Highlight lang="http">https://canny.io/api/v1/opportunities/list</Highlight>
          <APIDocsMethod />
          <APIDocsCurl
            path="https://canny.io/api/v1/opportunities/list"
            body={`\\
    -d apiKey=YOUR_API_KEY`}
          />
          <div className="text">Example Response</div>
          <Highlight lang="json">
            {`{
  "hasMore": false,
  "opportunities": [{
    "id": "61a942ed07bfe27b60109ee0",
    "closed": true,
    "name": "Opportunity Name",
    "postIDs": ["61a942ed07bfe27b60109eaf", "61a942ed07bfe27b60109ebc"],
    "salesforceOpportunityID": "0063k00000zx6BkAAI",
    "value": 1999.99,
    "won": true
  }]
}`}
          </Highlight>
        </div>
      </APIDocsBlock>
    );
  }
}
